import React from 'react';
import PropTypes from 'prop-types';
import PostSmallStyles from './styled.js';
import Picture from '../Picture/index.js';
import Category from '../Category/index.js';
import { Link } from 'react-router-dom';

const PostSmall = ({
  title = '',
  slug = '',
  thumbnail = '',
  contentTag = '',
  category = '',
  mediaType = '',
  ...props
}) => (
  <PostSmallStyles className='post_small' {...props}>
    <div className='thumbnail'>
      <Picture
        src={
          `${thumbnail}?h=80` ||
          'https://images.ctfassets.net/y64yks2od8ab/3UefaL6DWW86Zf2Hea0yEt/e3281a883561105a363b6bbe05c3ead0/defaultPost.jpg?h=80'
        }
        alt={`${title} post image`}
      />
    </div>
    <div className='data'>
      {category && <Category slug={contentTag} category={category} />}
      <a href={slug} className='type-h4'>
        {title}
      </a>
    </div>
  </PostSmallStyles>
);

PostSmall.propTypes = {
  title: PropTypes.string,
  slug: PropTypes.string,
  thumbnail: PropTypes.string,
  category: PropTypes.string,
  mediaType: PropTypes.string,
};

export default PostSmall;
